import React, { memo, useEffect, useCallback } from 'react';
import { List } from 'appkit-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import actions from '@flux/action';
import Card from './listCard';
import { insightModals } from '@model';
// import '@style/modules/insights/analysisInsightList.scss';
import '../../../../../styles/modules/analysis/analysisRight.scss';

function InsightList(props) {
  const {
    data = {},
    projectId,
    isFetchLoading,
    className,
    segment,
    category,
    uuid,
  } = props;
  const { changeConfig, fetchData, toggleFetchLoading, onCardClick } = props;

  const listData = Array.isArray(data[`${segment}-${category}`])
    ? data[`${segment}-${category}`]
    : [];
  const handleCardClick = (config) => {
    changeConfig(config);
  };

  const fetchListhData = useCallback(async () => {
    await fetchData({ projectId, segment, category, uuid });
  }, [projectId, segment, category, fetchData]);

  useEffect(() => {
    (async () => {
      toggleFetchLoading(true);
      await fetchListhData();
      toggleFetchLoading(false);
    })();
  }, []);
  useEffect(() => {
    if (
      data[`${segment}-${category}`] &&
      data[`${segment}-${category}`].length === 1
    ) {
      onCardClick({
        type: insightModals.INSIGHT_DETAIL,
        currentDetail: data[`${segment}-${category}`][0],
      });
    }
  }, [data]);
  const list = listData.map((item, index) => (
    <Card
      key={`analysis-insight-list-${index}`}
      sequence={index + 1}
      data={item}
      onClick={onCardClick || handleCardClick}
    />
  ));

  return (
    <div className={`analysis-insight-list ${className} pd30`}>
      <div className="insight-modal-header">
        <div className="insight-modal-title">Insight List</div>
      </div>

      {list?.length === 0 && !isFetchLoading ? (
        <div className="insight-modal-nodata">no insights</div>
      ) : (
        <List
          className={`insight-modal-content insight-modal-list-wrapper ${
            list.length > 3 ? 'overflow-y-scroll' : ''
          }`}
        >
          {list}
        </List>
      )}
    </div>
  );
}

InsightList.defaultProps = {
  onCardClick: null,
};

InsightList.propTypes = {
  data: PropTypes.array.isRequired,
  onCardClick: PropTypes.func,
};
const mapStateToProps = ({ common, analysis }) => {
  const projectId = common.currentId;
  return {
    data: (analysis.insightsData || {})[projectId] || {},
    projectId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  async fetchData(params) {
    await dispatch(actions.fetchAnalysisInsightData(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(InsightList));
